export const aboutData = {
    image: 2,
    title: "Dr.Simin",
    description1:" To industry, nothing is impossible",
    description2:"اولین و بزرگترین مرجع آرایشی و بهداشتی در ایران"
}